export default __webpack_public_path__ + "static/media/20C.0192729a.jpg";